import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Ukrainian Tax Number generator following Single Responsibility Principle
 */
export class UaGenerator extends BaseGenerator {
  generate() {
    // Generate first 9 digits
    const digits = this.randomDigits(9);
    
    // Calculate check digit
    const weights = [-1, 5, 7, 9, 4, 6, 10, 5, 7];
    let sum = 0;

    for (let i = 0; i < 9; i++) {
      sum += parseInt(digits[i]) * weights[i];
    }

    let checkDigit = sum % 11;
    if (checkDigit >= 10) {
      // Recalculate with different weights
      const weights2 = [7, 1, 3, 5, 8, 2, 4, 6, 9];
      sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(digits[i]) * weights2[i];
      }
      checkDigit = sum % 11;
      if (checkDigit >= 10) {
        checkDigit = 0;
      }
    }

    return digits + checkDigit;
  }
}